export const Grid = ({children, className}) => {
    return (
        <div className={`grid grid-cols-1 gap-8 mt-5 ${className}`}>{children}</div>
    );
};
